<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <a class="nav-link mr20"><icon name="user"></icon> {{globals.username}}</a>
        </template>
        <b-dropdown-item><a target="_blank" href="/"><icon name="globe"></icon> {{$t('OPENSITEINNEWWINDOW')}}</a></b-dropdown-item>
        <b-dropdown-item><a v-on:click="logout"><icon name="sign-out"></icon> {{$t('LOGOUT')}}</a></b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default
{
    name: 'header-dropdown-accnt',
    methods:
  {
      ...mapActions([
          'logout',
      ]),
  },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
  },
};
</script>
